export const RESPONSIVE_BREAK = 1000;
